import { put, select, take } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import { push } from 'redux-little-router';
import { updateDraft } from 'modules/Taps/components/NDFL3Light/redux/actions';
import { UPDATE_DRAFT_SUCCESS } from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { STEP_INCOME_FORM } from '../constants';

export function* submitIncomesSaga({ payload: { getNextStep } }) {
  const formData = yield select(getFormValues(STEP_INCOME_FORM));

  yield put(updateDraft({ draft: formData.set('currentFormId', 'submit') }));

  yield take(UPDATE_DRAFT_SUCCESS);
  yield put(push({ query: { step: getNextStep() } }, { persistQuery: true }));
}
